export const API_ADDR = process.env.REACT_APP_API_ADDR || 'http://exchangedev.xyz:8081'
export const WS_ADDR = process.env.REACT_APP_WS_ADDR || 'exchangedev.xyz:8081'
export const API_TOOL_ADDR_WALLET =
  process.env.REACT_APP_API_TOOL_ADDR_WALLET || 'http://exchangedev.xyz:8081'
export const API_TOOL_ADDR_WALLET_SOLIDITY =
  process.env.REACT_APP_API_TOOL_ADDR_WALLET_SOLIDITY || 'http://exchangedev.xyz:8081'
export const LBANK_WS_ADDR = process.env.REACT_APP_LBANK_WS_ADDR || 'wss://www.lbkex.net/ws/V2/'
export const CONTRACT_ADDR = ['WSwE9ychELmoPeVwVhMUWsJQZqk2JgfyWJ']
